<template>
    <el-drawer :title="formData.id ? '编辑报批方' : '创建报批方'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="450px" @close="close">
        <div class="drawer-content" v-loading="dataLoading">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
				<el-row :gutter="20">
					<el-form-item prop="companyName" :rules="[{required: true, message: '请填写营业执照上的企业名称'}]">
					    <span slot="label">企业名称 </span>
					    <el-input v-model="formData.companyName" placeholder="请填写企业名称" size="medium" maxlength="100"></el-input>
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item prop="licenseId" :rules="[{required: true, message: '请填写营业执照上的统一社会信用代码'}]">
					    <span slot="label">统一社会信用代码 </span>
					    <el-input v-model="formData.licenseId" placeholder="请填写统一社会信用代码" size="medium"  maxlength="100"></el-input>
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item  prop="businessType" label="企业类型" :rules="[{required: true, message: '请选择企业类型'}]" >
						<el-select v-model="formData.businessType" placeholder="请选择企业类型" size="small">
							<el-option :value="0" label="有限责任公司（自然人投资或控股）"></el-option>
							<el-option :value="1" label="股份有限公司"></el-option>
						</el-select>
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item prop="corporationName" label="法人代表姓名" :rules="[{required: true, message: '请填写法人代表姓名'}]" >
					    <el-input v-model="formData.corporationName" placeholder="请填写法人代表姓名" size="medium" maxlength="20"></el-input>
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item prop="registeredAddress" :rules="[{required: true, message: '请填写注册地址'}]"  label="注册地址">
						<el-input v-model="formData.registeredAddress" placeholder="请填写注册地址" size="medium"  maxlength="50"></el-input>
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item prop="registeredCapital" label="注册资本" :rules="[{required: true, message: '请填写注册资本'}]">
						<el-input-number  v-model="formData.registeredCapital" :precision="2"
							controls-position="right" :min="0" :max="100000" size="medium"
							placeholder="请填写注册资本" style="width: 90%;"></el-input-number>  万元
					</el-form-item>
				</el-row>
				<el-row :gutter="20">
					<el-form-item prop="licensePic" :rules="[{required: true, message: '请上传营业执照'}]" :show-message="formData.licensePic ? false : true">
					    <span slot="label">营业执照 <small>请上传营业执照副本扫描图,需带有公章</small></span>
					    <image-upload 
					        class="licensePic" 
					        :url.sync="formData.licensePic" 
					        :urlFull.sync="formData.licensePic">
					    </image-upload>
					</el-form-item>
				</el-row>
                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
const defaultData = {
    companyName: "",
    licenseId: "",
    corporationName: "",
	businessType:0,
    registeredAddress: "",
    registeredCapital: "",
    licensePic: "",
}
export default {
    props: {
       
    },
	components:{ImageUpload},
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                // parentId: [{ required: true, message: "请选择标签所属层级" }],
                // name: [{ required: true, message: "请填写名称" }],
                // processType: [{ required: true, message: "请选择加工类型" }],
                // valueLogic: [{ required: true, message: "请填写取值逻辑" }],
                // valueType: [{ required: true, message: "请选择取值类型" }],
                // updateCycle: [{ required: true, message: "请填写更新周期" }],
            },
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.formData = {
                ...defaultData
            }
            this.drawerShow = false;
        },
        show(data) {
            if (data) {
				console.log(data)
                this.formData = {
                    ...defaultData,
                    ...data
                }
            }
			
            this.drawerShow = true;
        },
        
        submitForm() {
			// if( this.formData.registeredCapital == 0 ){
			// 	return this.$message.error("注册资本必须大于0，请重新填写！");
			// }
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/approval/management/edit',
                        data: { ...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>